import React from "react";
import "./header.scss";
import Logo from "../../../media/logo-kbp.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faWhatsapp} from "@fortawesome/free-brands-svg-icons";

const headerkbp = () => {
  const waheader = () => {
    const whatsappLink =
      "https://api.whatsapp.com/send/?phone=6285720445400&text=Halo%20Rizki,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Kota%20Baru%20Parahyanganh%20https://kbp-kotabaruparahyangan.id//&type=phone_number&app_absent=0";
    window.open(whatsappLink, "_blank");
  };
  return (
    <div className="container-headerkbp">
      <div className="logokbp">
        <img className="gambarkbp" src={Logo} alt="logo-kbp" />
      </div>
      <div className="container-buttonwa">
        <button className="button" onClick={waheader}>
          <FontAwesomeIcon icon={faWhatsapp} /> Whatsapp
        </button>
      </div>
    </div>
  );
};

export default headerkbp;
